<script>
  import Trigger from "../Components/StartTriggers/Trigger.svelte";
  import TriggerOptions from "./TriggerOptions.svelte";
  import { clickForTriggerSettings } from "../static";
  import { ignore } from "../../Common/tools";
  import {External, M} from "../../external";

  export let data,
    onChange = ignore;
  let cmps = [];
  let counter = 0;

  export function get() {
    return data;
  }

  const onUpdate = (trigger) => {
    let index = 0;
    let count = 0;
    for (let count = 0; count < data.length; count++) {
      if (data[count].id === trigger.id) {
        index = count;
      }
    }
    data[index].name = trigger.name;
    data[index].type = trigger.type;
    data[index].settings = trigger.settings;
    onChange();
  };

  const onClick = (trigger) => {
    if (trigger && trigger.type) {
      clickForTriggerSettings(trigger.type, trigger, onUpdate);
    } else {
      let component;

      External.Tools.showWindow({
        title: M.CHOOSE_TRIGGER,
        icon: External.Popup.ICON_EDIT,
        width: 500,
        customClass: "add-member-dialog",
        isModal: false,
        withDarkBackground: true,
        forceAtRight: External.showBuilderPopupsOnFullHeight,
        markup: '<div class="popup-widget-wrapper bind-component"></div>',
        action: {
          onShow: function (popup, context) {
            component = new TriggerOptions({
              target: context.find(".bind-component")[0],
              props: {
                add: (trigger) => {
                  popup.close();
                  onAdd(trigger);
                }
              }
            });
          },
          onHide: function () {
            if (component) {
              component.$destroy();
              component = null;
            }
          }
        }
      });
    }
  };

  const onAdd = (newTrigger) => {
    counter = 0;
    if (data && data.length) {
      counter =
        Math.max.apply(
          Math,
          data.map(function (trig) {
            return trig.id;
          })
        ) + 1;
    }

    data = [
      ...data,
      {
        id: counter,
        name: newTrigger.name,
        type: newTrigger.type,
        settings: newTrigger.settings
      }
    ];
    onChange();
  };

  const onRemove = (index) => {
    External.Tools.prompt(M.DELETE, M.TRIGGER_DELETE_QST, function () {
      data = [...data.slice(0, index), ...data.slice(index + 1, data.length)];
      onChange();
    });
  };
  $: cmps = cmps.filter((el) => el);
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-25 mb-10 t-center h4-bigger">
    {M.AUTOMATION_FLOW_START_QST}
  </h4>
  <span class="light-gray-text t-center col20 f-left mb-15"
    >{M.AUTOMATION_FLOW_START_QST_DESC}</span
  >
  <ul>
    {#each data as trigger, index (trigger.id)}
      {#if index > 0}
        <span class='col20 f-left ta-center mt-5 mb-5'>{M.OR}</span>
      {/if}
      <Trigger
        bind:this={cmps[index]}
        bind:data={trigger}
        onClick={() => onClick(trigger)}
        onRemove={() => onRemove(index)}
      />
    {/each}
  </ul>
  <div class="col20 f-left mt-15 t-center">
    <a on:click={() => onClick(null)} class="middle-button with-icon blue f-none inline-block">{M.ADD_NEW_TRIGGER}</a>
  </div>
</div>
